var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.actionCompleted
      ? _c("div", { staticClass: "processing" }, [
          _c("h4", [_vm._v("Processing bulk action...")]),
          _c("p", [_vm._v("Please wait while we update your records.")]),
          _c(
            "div",
            { staticClass: "loader-container" },
            [
              _c("md-progress-spinner", {
                attrs: { "md-mode": "indeterminate", "md-diameter": 30 },
              }),
            ],
            1
          ),
        ])
      : _c(
          "div",
          { staticClass: "complete" },
          [
            _c("md-icon", { staticClass: "success-icon" }, [
              _vm._v("check_circle"),
            ]),
            _c("h4", [_vm._v("Bulk action completed successfully!")]),
            _c("p", [
              _vm._v(
                "It may take a few moments for the changes to appear in the Jobs grid."
              ),
            ]),
            _c(
              "md-button",
              {
                staticClass: "md-primary md-raised",
                on: { click: _vm.acknowledgeComplete },
              },
              [_vm._v("Close")]
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }